import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { toOrganizationTree } from 'src/app/_helpers/org-tree-helper';
import { OperatorTypeEnum } from 'src/app/enums/operatorType.enum';
import { OrgLevelTypeEnum } from 'src/app/enums/orgLevelType.enum';
import { AgentGroup } from 'src/app/models/agentGroup.model';
import { OrganizationLevel } from 'src/app/models/organizationLevel.model';
import { AgentGroupService } from 'src/app/services/agentGroup.service';
import { OrganizationLevelService } from 'src/app/services/organizationLevel.service';
import { FormComponent, IFormDialogData } from 'src/app/shared/form/form.component';
import { FormField, TextFormField, HierarchicalSelectionFormField } from 'src/app/shared/form/formField.model';
import nameOf from 'src/app/shared/form/nameOf.helper';

@Component({
  standalone: false,
  selector: 'app-agent-group-dialog',
  templateUrl: './../../shared/form/form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./../../shared/form/form.component.scss']
})
export class AgentGroupDialogComponent extends FormComponent<AgentGroup> implements OnInit {
  organizationLevels: OrganizationLevel[] = [];
  fields: FormField[] = [];

  constructor(
    dialogRef: MatDialogRef<AgentGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
    agentGroupService: AgentGroupService,
    private organizationLevelService: OrganizationLevelService,
    protected injector: Injector
  ) {
    super(dialogRef, agentGroupService, data, 'Agent Group', injector);
  }

  ngOnInit(): void {
    this.isFormLoading = true;
    const orgPayload = JSON.stringify({
      OperatorTypeEnum: JSON.stringify({
        Condition: OperatorTypeEnum.Equal,
        Field: nameOf<OrganizationLevel>(x => x.orgLevelType),
        Value: `${OrgLevelTypeEnum.Site},${OrgLevelTypeEnum.Function},${OrgLevelTypeEnum.BusinessUnit},${OrgLevelTypeEnum.Corporate}`
      })
    });
    forkJoin({
      entity: this.getEntity(),
      organizationLevels: this.organizationLevelService.getAll(orgPayload)
    }).subscribe(
      result => {
        this.entity = result.entity;
        this.organizationLevels = result.organizationLevels;
        this.initFields();
        this.isFormLoading = false;
      },
      error => {
        this.toastService.showError(error);
        this.isFormLoading = false;
      }
    );
  }

  override getNewObject(): AgentGroup {
    return new AgentGroup();
  }

  override validate(): boolean {
    return true;
  }

  initFields(): void {
    this.fields = [
      new TextFormField({
        property: nameOf<AgentGroup>(x => x.name),
        name: 'Agent Group Name',
      }),
      new TextFormField({
        property: nameOf<AgentGroup>(x => x.casId),
        name: 'Code',
      }),
      new HierarchicalSelectionFormField({
        property: nameOf<AgentGroup>(x => x.organizationLevelId),
        options: toOrganizationTree(this.organizationLevels),
        name: 'Visibility',
        required: true
      }),
    ];
  }

  closeDialog(data: Object = null) {
    this.dialogRef.close(data);
  }
}
